/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelInfo } from './cancel_info'
import type { OrderAccess } from './order_access'
import type { OrderCargoInfo } from './order_cargo_info'
import type { OrderItemClient } from './order_item_client'
import type { OrderItemDeparture } from './order_item_departure'
import type { OrderItemDestination } from './order_item_destination'
import type { OrderItemPartner } from './order_item_partner'
import type { OrderItemPoint } from './order_item_point'
import type { OrderOperationItem } from './order_operation_item'
/**
 * Данные заявки
 */
export type OrderItem = {
  /**
   * Номер заявки
   */
  serialId: number
  /**
   * Идентификатор заявки
   */
  id: string
  /**
   * Трек-номер заявки
   */
  barcode?: string
  /**
   * Статус заявки
   */
  status: OrderItem.Status
  /**
   * Статус оплаты заявки
   */
  paymentStatus: OrderItem.paymentStatus
  /**
   * Информация об отмене заявки
   */
  cancelInfo?: CancelInfo
  /**
   * Заказчик
   */
  customer: OrderItemClient
  /**
   * Плательщик
   */
  payer: OrderItemClient
  /**
   * Параметры пункта отправления
   */
  departure: OrderItemDeparture
  /**
   * Параметры пункта назначения
   */
  destination: OrderItemDestination
  /**
   * Отправитель
   * @deprecated
   */
  //  departurePartner: OrderItemPartner;
  /**
   * Получатель
   * @deprecated
   */
  //  destinationPartner: OrderItemPartner;
  /**
   * Плановая дата передачи груза
   * @deprecated
   */
  //  departureDate: string;
  /**
   * Плановая дата поступления груза на терминал выдачи
   * @deprecated
   */
  //  destinationDate?: string;
  /**
   * Плановая дата доставки груза курьером
   * @deprecated
   */
  //  destinationCourierDate?: string;
  /**
   * Пункт отправления
   * @deprecated
   */
  //  departurePoint: OrderItemPoint;
  /**
   * Пункт назначения
   * @deprecated
   */
  //  destinationPoint: OrderItemPoint;
  /**
   * Информация о грузе
   */
  cargoInfo: OrderCargoInfo
  /**
   * Цена (в рублях)
   */
  totalPrice: string
  /**
   * Длительность (в часах)
   */
  duration: number
  /**
   * Услуги по заявке
   */
  operation: Array<OrderOperationItem>
  /**
   * Комментарий к заявке
   */
  comment?: string
  /**
   * Принят ли груз у клиента (внесены фактические ВГХ, произведен окончательный расчет стоимости)?
   */
  isCargoAccepted: boolean
  /**
   * Права доступа
   */
  access?: OrderAccess
}
export namespace OrderItem {
  /**
   * Статус заявки
   */
  export enum Status {
    NEW = 'new',
    DEPARTURE_COURIER_ASSIGNED = 'departureCourierAssigned',
    DEPARTURE_COURIER = 'departureCourier',
    DEPARTURE_TERMINAL = 'departureTerminal',
    TRANSIT = 'transit',
    DESTINATION_TERMINAL = 'destinationTerminal',
    DESTINATION_COURIER_ASSIGNED = 'destinationCourierAssigned',
    DESTINATION_COURIER = 'destinationCourier',
    DELIVERED = 'delivered',
    CANCEL = 'cancel'
  }
  /**
   * Статус оплаты заявки
   */
  export enum paymentStatus {
    NO = 'no',
    PART = 'part',
    FULL = 'full',
    OVER = 'over'
  }
}
